const GRADIENTS = [
  'linear-gradient(135deg,#4f46e5,#7c3aed)',
  'linear-gradient(135deg,#0284c7,#0ea5e9)',
  'linear-gradient(135deg,#16a34a,#22c55e)',
  'linear-gradient(135deg,#dc2626,#ef4444)',
  'linear-gradient(135deg,#d97706,#f59e0b)',
]

function gradientForName(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return GRADIENTS[Math.abs(hash) % GRADIENTS.length]
}

function initials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('')
}

interface AvatarProps {
  name: string
  size?: number
}

export function Avatar({ name, size = 28 }: AvatarProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: gradientForName(name),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 700,
        fontSize: Math.round(size * 0.36),
        flexShrink: 0,
      }}
    >
      {initials(name)}
    </div>
  )
}
